/* import __COLOCATED_TEMPLATE__ from './offering-manager.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action, set } from '@ember/object';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import { TrackedAsyncData } from 'ember-async-data';
let OfferingManagerComponent = (_class = class OfferingManagerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "isEditing", _descriptor2, this);
    _initializerDefineProperty(this, "showRemoveConfirmation", _descriptor3, this);
    _initializerDefineProperty(this, "hoveredGroups", _descriptor4, this);
    _defineProperty(this, "textCopied", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(3000);
      }
    }), null, "textCopied", null));
  }
  get learnerGroupsData() {
    return new TrackedAsyncData(this.args.offering.learnerGroups);
  }
  get sessionData() {
    return new TrackedAsyncData(this.args.offering?.session);
  }
  get courseData() {
    return new TrackedAsyncData(this.session?.course);
  }
  get cohortsData() {
    return new TrackedAsyncData(this.course?.cohorts);
  }
  get learnerGroups() {
    return this.learnerGroupsData.isResolved ? this.learnerGroupsData.value : null;
  }
  get session() {
    return this.sessionData.isResolved ? this.sessionData.value : null;
  }
  get course() {
    return this.courseData.isResolved ? this.courseData.value : null;
  }
  get cohorts() {
    return this.cohortsData.isResolved ? this.cohortsData.value : null;
  }
  get cohortsLoaded() {
    return !!this.cohorts;
  }
  save(startDate, endDate, room, url, learnerGroups, learners, instructorGroups, instructors) {
    this.args.offering.setProperties({
      startDate,
      endDate,
      room,
      url,
      learnerGroups,
      learners,
      instructorGroups,
      instructors
    });
    return this.args.offering.save();
  }
  get sortedLearnerGroups() {
    if (!this.learnerGroups) {
      return [];
    }
    return this.learnerGroups.slice().sort((learnerGroupA, learnerGroupB) => {
      const locale = this.intl.get('locale');
      if ('title:desc' === this.sortBy) {
        return learnerGroupB.title.localeCompare(learnerGroupA.title, locale, {
          numeric: true
        });
      }
      return learnerGroupA.title.localeCompare(learnerGroupB.title, locale, {
        numeric: true
      });
    });
  }
  toggleHover(id) {
    if (this.hoveredGroups.includes(id)) {
      this.hoveredGroups = this.hoveredGroups.filter(theId => theId !== id);
    } else {
      this.hoveredGroups = [...this.hoveredGroups, id];
    }
  }
  setLearnerGroupElement(element, [id]) {
    set(this, `learnerGroupElement${id}`, element);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showRemoveConfirmation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hoveredGroups", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "learnerGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "learnerGroupsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cohortsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "cohortsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleHover", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleHover"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLearnerGroupElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLearnerGroupElement"), _class.prototype), _class);
export { OfferingManagerComponent as default };